import React from 'react';
import moment from 'moment';
export const options = {
  columns: [
    { id: 1, name: '', label: '', sortable: false },
    { id: 2, name: 'email', label: 'Email', sortable: true, type: 'number' },
    { id: 3, name: 'name', label: 'Name', sortable: true, type: 'string' },
    {
      id: 4, name: 'contact', label: 'Phone', sortable: true, type: 'string',
    },
    {
      id: 5, name: 'roleTenantList', label: 'Role', sortable: true, type: 'string',
      component: (row) =>
        (<div> {row.roleTenantList && row.roleTenantList.length ? row.roleTenantList.map((a, i) => <div key={a.roleId}>{a.roleName}</div>) : ''}</div>)
    }, {
      id: 6, name: 'isActive', label: 'Status', sortable: true, type: 'string', component: (row) =>
        (<div> {(row.roleTenantList[0].isActive == 1) ? "Active" : 'Inactive'}</div>)
    }



  ],
  keyCol: 'aId',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  }
  ],
  recActive: true,
  status: {
    key: 'isActive',
    active: '1',
    activeIcon: 'mdi mdi-checkbox-marked',
    inActiveIcon: 'mdi mdi-close-box',
    confirmation: true,
    activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  },
  actionsThead: false,
  sortable: false,
  dateType: true,
  defaultSortParams: {
    sortBy: 'BaseCurrency',
    sortOrder: 'desc'
  },
  showSearch: false,
  searchable: true,
  searchColumns: [
    { key: 'AlternateCurrency' }
  ],
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
}